import React, { useEffect, useState } from 'react';
import { ModuleBase, ResponsiveImage } from '@/components';
import { ImageModel, ModuleBaseModel, ModuleSectionPropsModel } from '@/types';
import Cookies from 'js-cookie';
import XLight from '@/assets/xLight.svg';

type NudgeWindowModel = ModuleBaseModel<
  {
    message: string;
    messageId: string;
    showUntil: string;
    backgroundColor?: string;
    bannerImage?: ImageModel;
    userCanDismiss?: boolean;
  } & ModuleSectionPropsModel
>;

const NudgeWindow = (data: NudgeWindowModel) => {
  const {
    props: { message, messageId, showUntil, bannerImage, userCanDismiss },
  } = data;
  const [isVisible, setIsVisible] = useState(false);

  const cookieName = 'ST_NDG_WNDW' + encodeURIComponent(messageId);

  useEffect(() => {
    const hasCookie = Cookies.get(cookieName);
    const isExpired = new Date(showUntil).getTime() < Date.now();

    if (!hasCookie && !isExpired) {
      setIsVisible(true);
    }
  }, [cookieName, showUntil]);

  if (!isVisible) {
    return null;
  }

  const onDismissClick = () => {
    Cookies.set(cookieName, 'true', {
      secure: true,
      sameSite: 'lax',
      path: '/',
      expires: new Date(showUntil),
    });
    setIsVisible(false);
  };

  return (
    <ModuleBase data={{ ...data, props: { ...data.props, backgroundColour: data.props.backgroundColor } }} noPadding>
      <div className="container flex flex-col p-3">
        {userCanDismiss && (
          <div className="flex justify-end">
            <button className="mb-2 cursor-pointer rounded-full bg-[#f5f5f5] p-1" onClick={onDismissClick}>
              <XLight className="h-6 w-6" />
            </button>
          </div>
        )}
        {bannerImage && (
          <ResponsiveImage
            image={bannerImage}
            className="mb-2 w-full"
            widths={{ xs: 425, sm: 640, md: 768, lg: 1024, xl: 1440, xxl: 1576 }}
            heights={{ xs: null }}
          />
        )}
        <div className="color-from-bg" dangerouslySetInnerHTML={{ __html: message }}></div>
      </div>
    </ModuleBase>
  );
};

export default NudgeWindow;
